import { AuthContext } from "../context/AuthContext";
//import { AuthContext } from "../contexts/AuthContext";
import { useContext } from "react";

export const useAuthContext = () => {
    const context = useContext(AuthContext);

    if (!context) {
        throw Error('useAuthContext must be used within n AuthContextProvider')
    }

    return context; //returns the state and dispatch
}